export default __webpack_public_path__ + "static/media/paymii.d6332362.svg";